import React from 'react';
import { render, screen } from '@testing-library/react';

import AppConfigProvider from './ConfigProvider';

describe('AppConfigProvider', () => {
  it('renders its children', () => {
    render(<AppConfigProvider>hello</AppConfigProvider>);

    expect(screen.getByText('hello')).toBeInTheDocument();
  });

  // Every Popover-backed overlay (tooltips, dropdown and select menus, date
  // pickers) is portaled into this root rather than rendered in place, which is
  // why an overlay's stacking is settled by its z-index alone and not by the
  // nesting of whatever opened it. See Toasts for a case that depends on it.
  it('creates the KeyDS portals root', () => {
    render(<AppConfigProvider>hello</AppConfigProvider>);

    expect(document.getElementById('key-popovers')).toBeInTheDocument();
  });
});
